<template>
    <div class="page scanCard">
        <div class="container min-h-100 d-flex flex-column justify-content-center">
            <div class="row">
                <div class="col-12">
                    <div class="text-center my-3">
                        <svg class="barcode w-100" :jsbarcode-value="this.user.member_id"></svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as JsBarcode from 'jsbarcode';
    export default {
        name: "MemberBarCode",
        created() {
            this.$store.commit("shared/setTopBar", {title: "Scan your reward card", showBackButton: true});
        },
        mounted() {
            JsBarcode(".barcode").init();
        }
    }
</script>
